export function pinchPreviewContentOrigin(
  scrollLeft: number,
  scrollTop: number,
  focalX: number,
  focalY: number
): { x: number; y: number } {
  return {
    x: scrollLeft + focalX,
    y: scrollTop + focalY,
  }
}

export function applyPinchPreviewTransform(
  element: HTMLElement,
  originX: number,
  originY: number,
  scale: number
): void {
  element.style.transformOrigin = `${originX}px ${originY}px`
  element.style.transform = `scale(${scale})`
  element.style.willChange = 'transform'
}

export function clearPinchPreviewTransform(element: HTMLElement): void {
  element.style.transformOrigin = ''
  element.style.transform = ''
  element.style.willChange = ''
}
